module.exports = __webpack_public_path__ + "static/media/avatar-ex.9d6eeea9.png";